import axios from 'axios';
import type { SupraSystemSubscriptionType } from '@bb/domain/dist/types/SupraSystemSubscription';

const addManualCoopKey = async ({
  keySerialNumber,
  pin,
}: {
  keySerialNumber: number;
  pin: string;
}): Promise<SupraSystemSubscriptionType | null> => {
  const { data } = await axios.post<SupraSystemSubscriptionType | null>(
    '/supra/manual_coop_key',
    { keySerialNumber, pin },
  );
  return data;
};

export default addManualCoopKey;
